import { render, staticRenderFns } from "./MonitShotScreen.vue?vue&type=template&id=47ce0944&scoped=true&"
import script from "./MonitShotScreen.vue?vue&type=script&lang=js&"
export * from "./MonitShotScreen.vue?vue&type=script&lang=js&"
import style0 from "./MonitShotScreen.vue?vue&type=style&index=0&id=47ce0944&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ce0944",
  null
  
)

export default component.exports